import { createWithEqualityFn as create } from 'zustand/traditional';

const MOBILE_MENU_TOP_SECTION_HEIGHT = 141;

export interface NavigationStore {
  isMobileMenuOpen: boolean;
  mobileMenuTopSectionHeight: number;
  resetAll: () => void;
  openMobileMenu: () => void;
  closeMobileMenu: () => void;
  setMobileMenuTopSectionHeight: (height: number | undefined) => void;
  navigationPath: number[];
  setNavigationPath: (path: number | number[]) => void;
  goBack: () => void;
  categoryId: number | null;
  setCategoryId: (id: number | null) => void;
  subcategoryId: number | null;
  setSubcategoryId: (id: number | null) => void;
}

export const useNavigationStore = create<NavigationStore>((set) => ({
  isMobileMenuOpen: false,
  mobileMenuTopSectionHeight: MOBILE_MENU_TOP_SECTION_HEIGHT,
  navigationPath: [],
  categoryId: null,
  subcategoryId: null,
  setCategoryId: (id) => {
    set(() => ({
      categoryId: id,
    }));
  },
  setSubcategoryId: (id) => {
    set(() => ({
      subcategoryId: id,
    }));
  },
  setNavigationPath: (path: number | number[]) => {
    set((state) => {
      if (Array.isArray(path)) {
        return {
          navigationPath: path,
        };
      }
      if (state.navigationPath.includes(path)) {
        return state;
      }
      return { navigationPath: [...state.navigationPath, path] };
    });
  },
  goBack: () => {
    set((state) => ({
      navigationPath: state.navigationPath.slice(0, -1),
    }));
  },
  resetAll: () => {
    set(() => ({
      navigationPath: [],
      categoryId: null,
      subcategoryId: null,
    }));
  },
  openMobileMenu: () => {
    set(() => ({
      isMobileMenuOpen: true,
    }));
  },
  closeMobileMenu: () => {
    set(() => ({
      isMobileMenuOpen: false,
    }));
  },
  setMobileMenuTopSectionHeight: (height) => {
    set(() => ({
      mobileMenuTopSectionHeight: height ?? MOBILE_MENU_TOP_SECTION_HEIGHT,
    }));
  },
}));
